import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/selectList.css";

class SelectList extends Component {
  state = {
    currentMouseOverItemId: null,
    isTouchMove: false,
    searchString: "",
  };

  isSelected = (id) => {
    const { selectedItems, idPropName } = this.props;
    return selectedItems.find((i) => i[idPropName] === id) !== undefined;
  };

  isDeleted = (id) => {
    const { deletedItems, idPropName } = this.props;
    if (deletedItems) return deletedItems.find((i) => i[idPropName] === id) !== undefined;
    return false;
  };

  isDisabled = (id) => {
    const { disabledItems, idPropName } = this.props;
    if (disabledItems)
      return disabledItems.find((i) => i[idPropName] === id) !== undefined;
    return false;
  };

  getSearchBarColClass = () => {
    // const { showAdd } = this.props;
    let sbcClass = "px-0 col-12";
    // if (showAdd) sbcClass += " col-10";
    // else sbcClass += " col-12";
    return sbcClass;
  };

  getSearchBarInputGroupClass = () => {
    // const { showAdd } = this.props;
    let sbIgClass = "input-group ml-0 mr-1 pl-0 w-100";
    return sbIgClass;
  };

  getLiClass = (id) => {
    let liClass = "list-group-item py-2 px-2";
    if (this.isDisabled(id))
      liClass = liClass + " cursor-not-allowed text-muted bg-white";
    else {
      if (this.isSelected(id)) liClass += " text-white bg-primary";
      else if (this.isDeleted(id)) liClass += " text-white bg-warning";
      liClass += " pointer-cursor";
    }
    return liClass;
  };

  renderIcon = (id) => {
    if (this.isCurrentMouseOverItem(id) || this.isSelected(id))
      return <FontAwesomeIcon icon="check" className="fa-fw mr-1" />;
    else if (this.isDeleted(id))
      return <FontAwesomeIcon icon="times" className="fa-fw mr-1" />;
    else return <FontAwesomeIcon icon="check" className="fa-fw icon-invisible mr-1" />;
  };

  isCurrentMouseOverItem = (id) => id === this.state.currentMouseOverItemId;
  handleMouseOver_item = (currentMouseOverItemId) => () =>
    !this.isDisabled(currentMouseOverItemId) && this.setState({ currentMouseOverItemId });
  // Reinitialize onMouseOut from listgroup.
  // Otherwise the hover check gets 'stuck' upon mouseOut
  handleMouseOut_listGroup = () => this.setState({ currentMouseOverItemId: null });
  handleTouchMove = () => this.setState({ isTouchMove: true });
  handleChange_searchString = (e) => this.setState({ searchString: e.target.value });

  handleClick_item = (id) => (e) => {
    e.preventDefault();
    const { selectedItems, idPropName, onSelect, onDeselect } = this.props;
    // For touch devices, only capture "taps" - not scrolling movements
    if (!this.state.isTouchMove) {
      if (!this.isDisabled(id)) {
        // If item is already selected, then remove
        if (selectedItems.filter((d) => d[idPropName] === id).length > 0) onDeselect(id);
        else onSelect(id);
      }
    }
    this.setState({ isTouchMove: false });
  };

  handleClick_add = (e) => {
    e.preventDefault();
    this.props.onClick_add();
  };

  getData = () => {
    const { data, columns, showSearch } = this.props;
    const { searchString } = this.state;
    if (!showSearch) return data;
    return searchString === "" || searchString == null
      ? data
      : data.filter((i) =>
          columns
            .map((c) => i[c.path])
            .join(" ")
            .toLowerCase()
            .includes(searchString.toLowerCase())
        );
  };

  render() {
    const {
      columns,
      idPropName,
      parentClassName,
      className,
      showSearch,
      showAdd,
      addCaption,
      placeholderText,
    } = this.props;
    const { searchString } = this.state;
    const data = this.getData();
    return (
      <React.Fragment>
        <div className={parentClassName}>
          {showSearch && (
            <div className="row form-inline mx-0 mb-1">
              <div className="px-0 col">
                <div className="input-group ml-0 mr-1 pl-0 w-100">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <FontAwesomeIcon icon="search" className="fa-fw" />
                    </span>
                  </div>
                  <input
                    type="text"
                    maxLength="75"
                    name="searchString"
                    id="searchString"
                    className="form-control"
                    value={searchString}
                    onChange={this.handleChange_searchString}
                  />
                  {showAdd && (
                    <div className="input-group-append">
                      <button
                        type="button"
                        id="add"
                        name="add"
                        className="btn btn-info"
                        onClick={this.handleClick_add}
                      >
                        <FontAwesomeIcon
                          icon="plus"
                          className={"fa-fw px-0 " + (addCaption && "mr-2 " + addCaption)}
                        />
                        {addCaption}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <ul
            className={"list-group list-group-flush " + className}
            onMouseOut={this.handleMouseOut_listGroup}
          >
            {data && data.length > 0 ? (
              data.map((d) => (
                <li
                  key={`listGroupItemKey_${d[idPropName]}`}
                  className={this.getLiClass(d[idPropName])}
                  onMouseOver={this.handleMouseOver_item(d[idPropName])}
                  onClick={this.handleClick_item(d[idPropName])}
                  onTouchMove={this.handleTouchMove}
                  onTouchEnd={this.handleClick_item(d[idPropName])}
                >
                  <div className="form-row">
                    <span>{this.renderIcon(d[idPropName])}</span>
                    {columns.map((c) => (
                      <div
                        key={`lgItemColKey_${d[idPropName]}_${c.path}`}
                        className={c.colSize}
                      >
                        {_.get(d, c.path)}
                      </div>
                    ))}
                  </div>
                </li>
              ))
            ) : (
              <li key="listGroupItemKey_empty" className="list-group-item py-2 px-2">
                <span>{placeholderText}</span>
              </li>
            )}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

SelectList.propTypes = {
  // Optional className for the container div
  parentClassName: PropTypes.string,
  // Optional className for listGroup
  className: PropTypes.string,
  // Items to populate the list with
  data: PropTypes.array,
  // Array of selected items from the 'data'
  selectedItems: PropTypes.array,
  // Columns to show in each line. Array of { path: PropTypes.string }
  columns: PropTypes.array,
  // Name of 'id' for data. Set as 'null' for array of integers
  idPropName: PropTypes.string,
  // Handler for selecting a new item to 'selectedItems'
  onSelect: PropTypes.func,
  // Handler for removing selected item from 'selectedItems'
  onDeselect: PropTypes.func,
  // Show search input above 'ul'
  showSearch: PropTypes.bool,
  // Show add button next to search input
  showAdd: PropTypes.bool,
  // Allow tracking of deleted items
  deletedItems: PropTypes.array,
  // Allow tracking of newly added items (re-selecting one of the selectedItems doesn't count)
  addedItems: PropTypes.array,
  // Items to disable
  disabledItems: PropTypes.array,
  // Handler for adding new data w/'Add' button
  onClick_add: PropTypes.func,
  // Placeholder text when data is empty
  placeholderText: PropTypes.string,
};

export default SelectList;
